import React, { useEffect } from 'react';
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './AboutUs.css';

const AboutUs = () => {
  useEffect(() => {
    // Smooth scroll
    var html_body = $('html, body');
    $('.navbar a , .scroll-down a , .backtotop a').on('click', function () {
      if (
        window.location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
        window.location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          html_body.animate(
            {
              scrollTop: target.offset().top - 65,
            },
            1500
          );
          return false;
        }
      }
    });

    // Preloader
    $(window).on('load', function () {
      $('.preloader').delay(1000).fadeOut(1000);
    });
    setTimeout(() => {
      $('.preloader').fadeOut(1000);
    }, 2000);
  });

  return (
    <>
      <Header />
      <div className="container-fluid about-us-container">
        <div className="preloader">
          <div className="frame">
            <div className="center">
              <div className="dot-1"></div>
              <div className="dot-2"></div>
            </div>
          </div>
        </div>

        <section id="about-us-page" className="about-us-section">
          <div className="design-layer"></div>
          <div className="backtotop">
            <a href="#about-us-page">
              <i className="fa fa-arrow-up" aria-hidden="true"></i>
            </a>
          </div>

          <div className="container zindex">
            <div className="about-hero">
              <h3>
                Turn <span className="highlight">Happy Customers</span> Into Your Best Marketers.
              </h3>
              <p>
                RefMex helps businesses grow through word-of-mouth. Share referral links or QR codes — customers earn
                loyalty points for every successful referral, while their friends enjoy instant discounts. RefMex turns
                your loyal customers into brand ambassadors — right at the point of sale.
              </p>
            </div>

            <div className="about-content-section">
              <div className="about-card">
                <h2 className="about-section-title">
                  <i className="fa fa-bullseye about-icon"></i> What We Do
                </h2>
                <ul className="about-feature-list">
                  <li>
                    <i className="fa fa-check-circle check-style"></i> QR and link-based referral sharing that works on any device
                  </li>
                  <li>
                    <i className="fa fa-check-circle check-style"></i> Automatic loyalty point tracking for every successful referral
                  </li>
                  <li>
                    <i className="fa fa-check-circle check-style"></i> Custom referral campaign builder for unique business goals
                  </li>
                  <li>
                    <i className="fa fa-check-circle check-style"></i> Real-time analytics to track top referrers and conversions
                  </li>
                  <li>
                    <i className="fa fa-check-circle check-style"></i> Easy API integration with your POS or CRM systems
                  </li>
                </ul>
              </div>

              <div className="about-card">
                <h2 className="about-section-title">
                  <i className="fa fa-users about-icon"></i> Who We Serve
                </h2>
                <p>
                  RefMex empowers businesses of all types — from restaurants and salons to retail chains and clinics —
                  helping them grow through trusted, organic referrals instead of costly ads.
                </p>
                <div className="industry-icons">
                  <i className="fa fa-cutlery" aria-hidden="true"></i>
                  <i className="fa fa-scissors" aria-hidden="true"></i>
                  <i className="fa fa-shopping-bag" aria-hidden="true"></i>
                  <i className="fa fa-heartbeat" aria-hidden="true"></i>
                </div>
              </div>

              <div className="row about-card-group">
                <div className="col-md-6">
                  <div className="about-card flex-grow-1">
                    <h2 className="about-section-title">
                      <i className="fa fa-gift about-icon"></i> Why It Matters
                    </h2>
                    <p>
                      Ads are temporary. Referrals are lasting. With RefMex, your existing customers become a powerful,
                      self-sustaining marketing channel that grows your business organically and cost-effectively.
                    </p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="about-card flex-grow-1">
                    <h2 className="about-section-title">
                      <i className="fa fa-flag about-icon"></i> Our Mission
                    </h2>
                    <p>
                      Our mission is simple — to make referral marketing effortless for every business. RefMex helps you
                      reward loyalty, build community, and grow smarter through the people who already trust your brand.
                    </p>
                  </div>
                </div>
              </div>

              <div className="about-card mt-4">
                <h2 className="about-section-title">
                  <i className="fa fa-line-chart about-icon"></i> Analytics & Insights
                </h2>
                <p>
                  With our real-time dashboard, track referral performance, top referrers, redeemed points, and
                  conversion trends — all in one place. Export detailed reports to keep your marketing data actionable
                  and transparent.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default AboutUs;
